import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const LoadMoreButton = ({ t, onClick, loading }) => {
  return (
    <div className="chat__load-more">
      {loading ? (
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <button type="button" onClick={onClick}>
          {t('general.load-more')}
        </button>
      )}
    </div>
  );
};

LoadMoreButton.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withTranslation('common')(LoadMoreButton);
